import React from 'react'
import { Col, Row } from 'antd'
import HumanReviewProgressCard from '../analytics-section/text/human-review-progress/HumanReviewProgressCard'
import DistributionBetweenPhasesCard from '../analytics-section/text/distribution-between-phases/DistributionBetweenPhasesCard'
import Phases from '../../../../../constants/model-phases'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import EscalatedSubmissionsCard from './escalated-submissions/EscalatedSubmissionsCard'

const DashboardSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(`${assignmentName || ''} Dashboard`)

    return (
        <Row gutter={16}>
            <Col span={12} className='mb-16'>
                <EscalatedSubmissionsCard />

                <HumanReviewProgressCard />
            </Col>
            <Col span={12} className='mb-16'>
                <DistributionBetweenPhasesCard
                    title='Historical vs Human-reviewed'
                    phasesToShow={[Phases.HISTORICAL, Phases.HUMAN_REVIEWED]}
                />
            </Col>
        </Row>
    )
}

export default DashboardSection
